export const PasswordEyeOpen = ({ width, className }: { width: string; className: string }) => (
   <svg className={className} id="Suche" width={width} height="18.112" viewBox="0 0 26.564 18.112">
      <defs>
         <clipPath id="clip-path">
            <path
               id="Eye"
               d="M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z"
               transform="translate(0 0)"
               fill="#6c727c"
            />
         </clipPath>
      </defs>
      <path
         id="Eye-2"
         data-name="Eye"
         d="M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z"
         transform="translate(0 0)"
         fill="#6c727c"
      />
   </svg>
);

export const PasswordEyeInactive = ({ width, className }: { width: string; className: string }) => (
   <svg
      className={className}
      id="Suche"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height="18.112"
      viewBox="0 0 26.564 18.112"
   >
      <defs>
         <clipPath id="clip-path">
            <path
               id="Eye"
               d="M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z"
               transform="translate(0 0)"
               fill="#dfe2e6"
            />
         </clipPath>
      </defs>
      <path
         id="Eye-2"
         data-name="Eye"
         d="M13.283,18.112a14.167,14.167,0,0,1-8.122-2.54A14.3,14.3,0,0,1,0,9.056a14.27,14.27,0,0,1,26.564,0,14.288,14.288,0,0,1-5.16,6.516A14.165,14.165,0,0,1,13.283,18.112Zm0-15.094a6.038,6.038,0,1,0,6.037,6.038A6.045,6.045,0,0,0,13.283,3.018Zm0,9.66a3.622,3.622,0,1,1,3.622-3.622A3.627,3.627,0,0,1,13.283,12.679Z"
         transform="translate(0 0)"
         fill="#dfe2e6"
      />
   </svg>
);
